import { HomeIcon } from "@coworker/apprestructured/src/shared/components/HomeIcon/HomeIcon";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./item-location.module.css";

interface ItemLocationProps {
  locationGridCode: string;
}

export const ItemLocation = ({ locationGridCode }: ItemLocationProps) => {
  return (
    <div className={styles["item-location-container"]}>
      <HomeIcon variant={"small"} />
      <FixaText
        className={styles["item-location-text"] || ""}
        textStyle={"Body.L"}
      >
        {locationGridCode}
      </FixaText>
    </div>
  );
};
